import * as React from 'react';

import ListMonthContainer from '../../components/list/container';

import { PackageListingContainerProps } from '../../components/package-listing-container';


const PackageListingContainerView: React.StatelessComponent<PackageListingContainerProps> = props => {
    let component: JSX.Element = null;

    component = <ListMonthContainer />;
    return (
        <ListMonthContainer />
    )
}

export default PackageListingContainerView;